import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { aiAgentApiRef } from './api/AiAgentApi';
import { AiAgentClient } from './api/AiAgentClient';

export const aiAgentChatPlugin = createPlugin({
  id: 'ai-agent-chat',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: aiAgentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiAgentClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const AiAgentChatPage = aiAgentChatPlugin.provide(
  createRoutableExtension({
    name: 'AiAgentChatPage',
    component: () =>
      import('./components/ChatPage').then(m => m.ChatPage),
    mountPoint: rootRouteRef,
  }),
);
